import styled from 'styled-components';

export const Path = styled.path`
  transition: fill 0.2s linear;
  stroke: white;
  stroke-width: 2.2;
  fill: ${({ filled }) => (filled ? 'white' : 'none')};
`;
